<bn-layout-search
  [debounceMs]="debounceMs"
  [isLoading]="isLoading"
  [isOpen]="isOpen"
  [minSearchTermLength]="minSearchTermLength"
  (arrowDown)="onArrowDown()"
  (arrowUp)="onArrowUp()"
  (clear)="onClear()"
  (clickOutside)="onClickOutside()"
  (enter)="onEnter()"
  (escape)="onEscape()"
  (inputClick)="onInputClick()"
  (searchTermChange)="onSearchTermChange($event)">
  <div class="bn-search__dropdown">
    @for (group of groupedSearchResults | keyvalue; track group) {
      <div class="bn-search__dropdown__group">
        <div class="bn-search__dropdown__group__title">{{ group.value?.name }}</div>
        <ul class="bn-search__dropdown__group__results">
          @for (searchResult of group.value?.searchResults; track searchResult) {
            <li
              class="bn-search__dropdown__group__results__item"
              [ngClass]="{
                'bn-search__dropdown__group__results__item--selected': searchResult.actualIndex === selectedIndex,
              }"
              (click)="onSearchItemClick(searchResult, group.value?.href)">
              <span>
                @if (group.value && group.value.icon) {
                  <fa-icon
                    size="sm"
                    [icon]="group.value.icon" />
                }
                <span
                  bnWebUiHighlightWords
                  class="ms-2"
                  [searchedWords]="searchTerm.trim().split(' ')"
                  [text]="searchResult.Name"></span>
              </span>
              <span class="bn-search__dropdown__group__results__item__arrow">
                <fa-icon
                  icon="arrow-right"
                  size="xs" />
              </span>
            </li>
          }
        </ul>
      </div>
    }
    @if (!(groupedSearchResults | keyvalue).length) {
      <div class="bn-search__dropdown__no-results">
        <div class="bn-search__dropdown__no-results__title">
          No results for <strong>{{ searchTerm }}</strong
          >.
        </div>
        <div class="bn-search__dropdown__no-results__content mb-3">Try something else?</div>
        <img src="/assets/images/bunny-laptop-dragon.svg" />
      </div>
    }
  </div>
</bn-layout-search>
